import {useState} from 'react'
import {CrwalTable} from './CrwalTablePDF'
import {InputCard} from './InputFieldsPDF'
import {QueryRequestProvider} from '../scrapping-table/core/QueryRequestProvider'
import {QueryResponseProvider} from '../scrapping-table/core/QueryResponseProvider'
import {ListViewProvider} from '../scrapping-table/core/ListViewProvider'
import {OutPutView} from './OutputViewPDF'
import {fetchPdfFileContent} from '../scrapping-table/core/_requests'

const MainScrappingPDF = () => {
  const [tableloading, setTableLoading] = useState(false)
  const [data, setData] = useState('')
  const [pdfFiles, setPDFFiles] = useState<File[]>([])
  const [pdfContent, setpdfContent] = useState('')
  const [fetchingFileCount, setFetchingCount] = useState(0)

  const handleLoading = async () => {
    setTableLoading(true)
    await uploadAllFiles()
  }

  const callTheAPI = async (file: any) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await fetchPdfFileContent(formData)
      const fileContent = response.content
      setpdfContent((prevData) => prevData + fileContent)
    } catch (error) {
      console.error('Error uploading file:', error)
    }
  }

  function timeout(delay: number) {
    return new Promise((res) => setTimeout(res, delay))
  }

  const uploadAllFiles = async () => {
    setTableLoading(true);
    let totalFetchedFiles = 0;
  
    for (let i = 0; i < pdfFiles.length; i++) {
      const file = pdfFiles[i];
      try {
        const formData = new FormData();
        formData.append('file', file);
        await timeout(2000);
        await callTheAPI(file);
        totalFetchedFiles++;
        setFetchingCount(totalFetchedFiles);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
    setTableLoading(false);  
   
  };

  const updateDataView = () =>{
    setData(pdfContent);
    setPDFFiles([]);
  }
  

  return (
    <div>
      <InputCard
        tableLoading={tableloading}
        handleTableLoading={handleLoading}
        searchTerm={pdfFiles}
      />
      {!data ? (
        <CrwalTable
          setSelectedData={updateDataView}
          fileData={pdfFiles}
          setDataHandler={setPDFFiles}
          tableLoading={tableloading}
          fetchFileCount={fetchingFileCount}
          data={data}
        />
      ) : (
        <OutPutView data={data} clearData={setData} websiteUrl={'pdfFiles'} />
      )}
    </div>
  )
}

const MainScrappingWrapperPdf = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <MainScrappingPDF />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {MainScrappingWrapperPdf}
